import * as React from "react";
import EdButton, { EdLinkButton } from "../../../generic/edButton";
import { EResetSubmitState } from "../../../login/loginConstants";
import Search from "../../../generic/search";
import Table from "./table";
import Pagination from "../../../generic/pagination";
import EdModal from "../../../generic/edModal";
import { FinalPopupScreen } from "../../generic/finalPopupScreeen";
import { GenerateLead } from "../../../service/gba/gbaApiService";
// @ts-ignore
import * as XMLParser from "react-xml-parser";
import { logout } from "../../../service/login/loginService";
import { config } from "../../../../config/domain";
import { getServicingDetails } from "../../../service/serviceRequest/srApiService";
import { AccountReactivationConsent } from "../accReactivate/accReactCnst";
export interface IChangePasswordScreenProps {}

export interface IChangePasswordScreenState {
  errorMsg?: string;
  popupMessage?: string;
  submitState?: EResetSubmitState;
}

const SRContainer: React.FC<any> = (props) => {
  const [accType, selectedAccType] = React.useState("");
  const [selectedStatus, setSelectedStatus] = React.useState("All");
  const [serviceList, setServiceList] = React.useState<any>();
  const [searchList, setSearchList] = React.useState({ data: [], name: "" });
  const [filterData, setFilterData] = React.useState([]);
  const [open, setOpen] = React.useState<boolean>(false);
  const [accTypeList, setAccTypeList] = React.useState<string[]>([]);
  const [lead, setLead] = React.useState<undefined | boolean>();
  const [error, setError] = React.useState<undefined | boolean>(false);
  const [changeAcc, setChangeAcc] = React.useState<any>({});
  const [rmName, setRMName] = React.useState<any>();
  async function getRMName() {
    let details = await getServicingDetails();
    if (details) {
      setRMName(details.tradingDealerNameField);
    }
  }

  React.useEffect(() => {
    getRMName();
    selectedAccType(props.accType);
    setAccTypeList(props.accList);
    setServiceList({
      All: props.serviceReq,
      Approved:
        props.serviceReq.length > 0
          ? props.serviceReq.filter(
              (req: any) => req.RequestStatus === "Approved"
            )
          : [],
      Processed:
        props.serviceReq.length > 0
          ? props.serviceReq.filter(
              (req: any) => req.RequestStatus === "Processed"
            )
          : [],
    });
  }, [props.accType]);
  React.useEffect(() => {}, [selectedStatus]);

  const leadGenerate = async () => {
    const { emailAddressField, nameField, mobileNumberField } = props.profile;
    const payload = {
      Email: emailAddressField,
      Name: nameField,
      Phone: mobileNumberField,
      ProductNames: changeAcc.display,
      ProductPage: "EWINNONCLIENT",
    };
    try {
      const xmlText = await GenerateLead(payload);
      const leadRes = new XMLParser().parseFromString(xmlText);
      leadRes.value === "Success" ? setLead(true) : setLead(false);
    } catch (err) {
      setError(true);
    }
  };

  function closeModal() {
    setError(false);
    setOpen(false);
  }
  const accList = [
    { value: "EQ", display: "Equity" },
    { value: "CO", display: "COMMODITIES" },
  ];
  const statusFilterList = [
    { value: "All", display: "All" },
    { value: "Processed", display: "Closed" },
    { value: "Approved", display: "Pending" },
  ];
  const ModalBody = () => {
    return (
      <div className="modal-dialog modal-dialog-centered common-modal-deisgn commodityPopup">
        <div className="modal-content top-brdr-block">
          {lead === undefined &&
            !error &&
            !accTypeList.includes(changeAcc.value) && (
              <>
                <div className="modal-header">
                  <h4 className="modal-title">
                    You will need a {changeAcc.display} account to transact in{" "}
                    {accType === "EQ" ? "commodities" : "equities"}.
                  </h4>
                  <a
                    role="button"
                    onClick={() => {
                      setOpen(false);
                    }}
                    title="Close"
                    className="cancel"
                  >
                    <i className="edel-icon-close"></i>
                  </a>
                </div>
                <div className="modal-body">
                  <div className="wrap-header text-center">
                    <p>Would you like to open one now?</p>
                  </div>
                  <div className="display-flex btn_links">
                    <EdButton
                      type="button"
                      btnTyp="primary"
                      value="Yes,Right Away"
                      onClick={() => leadGenerate()}
                    />
                    <EdButton
                      btnTyp="link"
                      value="No Thanks"
                      onClick={() => {
                        setOpen(false);
                      }}
                    />
                  </div>
                </div>
              </>
            )}
          {lead && (
            <FinalPopupScreen
              popupData={{
                headerText: "We've received your request!",
                content:
                  "Our representative will get in touch with you shortly",
                btnText: "Ok, Got it",
                type: "submit",
              }}
              onClick={closeModal}
            />
          )}
          {lead === false && (
            <FinalPopupScreen
              popupData={{
                headerText: "We've Already received your request!",
                content:
                  "Our representative will get in touch with you shortly.",
                btnText: "Ok, Got it",
                type: "submit",
              }}
              onClick={closeModal}
            />
          )}

          {error && lead === undefined && (
            <FinalPopupScreen
              popupData={{
                headerText: "We are facing Some Technical Issue!",
                content: "Please try again later!",
                btnText: "Ok, Got it",
                type: "error",
              }}
              onClick={closeModal}
            />
          )}

          {accList.length > 1 && accTypeList.includes(changeAcc.value) && (
            <>
              {" "}
              <div className="modal-header">
                <h4 className="modal-title">
                  Do you want to login to your {changeAcc.display} account ?
                </h4>
                <a
                  role="button"
                  onClick={() => {
                    setOpen(false);
                  }}
                  title="Close"
                  className="cancel"
                >
                  <i className="edel-icon-close"></i>
                </a>
              </div>
              <div className="modal-body">
                <div className="display-flex btn_links">
                  <EdButton
                    type="button"
                    btnTyp="primary"
                    value="Proceed & Logout"
                    onClick={() => {
                      logout();
                      window.location.href = `${config.rootUrl}?ottype=service-request`;
                    }}
                  />
                  <EdButton
                    btnTyp="link"
                    value="Cancel"
                    onClick={() => {
                      setOpen(false);
                    }}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };
  return (
    <>
      <div>
        <div className="serviceRequest_card">
          <div className="text-center">
            <h3>Service Requests</h3>

            <div className="acc-types">
              <ul className="tag_navigation_content">
                {accList.map((tag) => (
                  <li
                    className={"tag" + (tag.value === accType ? " active" : "")}
                    key={tag.value}
                    onClick={() => {
                      setChangeAcc(tag);
                      setOpen(true);
                    }}
                  >
                    <a href="#" className="">
                      {tag.display}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <div className="serviceRequest_create">
                <EdLinkButton
                  LinkHref="/clientarea/service-request/open"
                  value="Create Service Request"
                  btnTyp="primary"
                  className=""
                />
                {searchList.name === "" && (
                  <div className="">
                    {serviceList && (
                      <ul className="tag_navigation_content">
                        {statusFilterList.map((filter) => {
                          if (
                            serviceList[`${filter.value}`] &&
                            serviceList[`${filter.value}`].length > 0
                          ) {
                            return (
                              <li
                                className={
                                  "tag serviceRequest_create--tag" +
                                  (filter.value === selectedStatus
                                    ? " active"
                                    : "")
                                }
                                key={filter.value}
                                onClick={() => setSelectedStatus(filter.value)}
                              >
                                <a className="notification">
                                  <span>{filter.display}</span>
                                  {serviceList[`${filter.value}`] && (
                                    <span className="badge">
                                      {serviceList[`${filter.value}`].length}
                                    </span>
                                  )}
                                </a>
                              </li>
                            );
                          }
                        })}
                      </ul>
                    )}
                    {serviceList && serviceList.All.length === 0 && (
                      <span className="noSr-head">No service Request</span>
                    )}
                  </div>
                )}

                <div className="search">
                  {serviceList && serviceList.All.length > 0 && (
                    <Search
                      onSearch={(data: any, name: any) => {
                        setSearchList({
                          data,
                          name,
                        });
                      }}
                      searchKey={"RequestType"}
                      searchList={[serviceList["All"]]}
                      placeholder="Search"
                    />
                  )}
                </div>
              </div>
            </div>

            {serviceList && serviceList.All.length > 0 && (
              <Table
                sourceData={filterData ? filterData : []}
                rmName={rmName}
              />
            )}
          </div>
        </div>
        <div className="pagination-tab">
          {serviceList && serviceList[selectedStatus].length > 0 && (
            <Pagination
              totalRecords={
                searchList?.name !== ""
                  ? searchList.data[0]
                  : serviceList[selectedStatus]
              }
              pageLimit={5}
              onPageChange={(newdata: any) => {
                setFilterData(newdata.filteredRecords);
              }}
            />
          )}
        </div>
      </div>
      {/* <AccountReactivationConsent /> */}
      <EdModal
        show={open}
        close={() => {
          setOpen(false);
        }}
        children={ModalBody()}
      />
    </>
  );
};

export default SRContainer;
